import { render, staticRenderFns } from "./closeChallengeModal.vue?vue&type=template&id=bc60e082&"
import script from "./closeChallengeModal.vue?vue&type=script&lang=js&"
export * from "./closeChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./closeChallengeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports